// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_1moI-KdVgq8Dn8p2Uc5vfd","header-delete":"_3BwLHDZaX5aAg3XPn0TCt_","title-modal":"_3EHXFtZ0z0NFk3GJKoZpOY"};